import './styles.css';
import React, { memo, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import GraphPanel from "./GraphPanel";

const ResponsiveGridLayout = WidthProvider(Responsive);

const ChartsLayout = memo(forwardRef((props, ref) => {
    const { fields, layouts, selectedChart,
        crossHair=false, enableZoom,
        data, isLoading, isError, error,
    } = props;
    const chartRefs = useRef([]);
    const containerRefs = useRef([]);
    let chartsData = [];

    useImperativeHandle(ref, () => ({
        resetZoomAll() {
            chartRefs?.current.forEach(ref => {
                const chart = ref;
                if (chart) chart.zoomOut();
            });
        }
    }));

    chartsData = fields?.map((field) => data?.data.map((entry) => [entry.timestamp, entry[field.value]]));

    const syncZoom = (min, max, sourceChartIndex) => {
        chartRefs?.current.forEach((ref, index) => {
            if (index !== sourceChartIndex) {
                if (ref) {
                    ref?.xAxis?.[0]?.setExtremes(min, max, true, false, { trigger: 'sync' });
                }
            }
        });
    };

    const syncCrosshairs = (e) => {
        chartRefs?.current.forEach(ref => {
          if (ref) {
            const event = ref?.pointer?.normalize(e);
            event.chartX = event ? e?.offsetX : null;// (Please do not delete this)
            const point = event ? ref?.series?.[0]?.searchPoint(event, true) : null;
            if (point) {
                point.onMouseOver();
                ref?.tooltip?.refresh(point, event);
                ref?.xAxis?.[0].drawCrosshair(event, point);
            }
          }
        });
    };
    
    const clearCrosshairs = () => {
        chartRefs.current.forEach(ref => {
            ref?.tooltip?.hide();
            ref?.xAxis?.[0]?.hideCrosshair();
        });
    };

    useEffect(() => {
        if (fields?.length !== chartRefs?.length){
            chartRefs.current = Array.from({ length: fields.length }, (_, i) => chartRefs.current[i] || null);
            containerRefs.current = Array.from({ length: fields.length }, (_, i) => containerRefs.current[i] || null);
        }  
    }, [layouts, fields]);


    return (
        <ResponsiveGridLayout
            layouts={layouts}
            breakpoints={{ lg: 1200, md: 996, sm: 768 }}
            cols={{ lg: 12, md: 12, sm: 12 }}
            rowHeight={30}
            margin={[10, 12]}
            isDraggable={false}
            isResizable={false}
            preventCollision={true}
        >
            {chartRefs?.current?.map((_, i) => {
                return(
                    <div key={`panel${i+1}`} className="panelStyle">
                        <GraphPanel 
                            title={fields?.[i]?.title + ` (${fields[i]?.unit})`}
                            plotType={selectedChart} 
                            panelData={chartsData[i]}
                            panelSeries={fields[i]?.value}
                            // panelUnits={fields[i]?.unit} 
                            isLoading={isLoading} 
                            isError={isError} 
                            dataErrorMsg={error?.message}         
                            enableZoom={enableZoom}
                            syncZoom={syncZoom}
                            crossHair={crossHair}
                            onCursorMove={crossHair ? syncCrosshairs : null}
                            onCursorLeave={crossHair ? clearCrosshairs : null}  
                            setChartRef={(chart) => (chartRefs.current[i] = chart)}
                            setContainerRef={(container) => containerRefs.current[i] = container}
                            chartIndex={i}
                        />
                    </div>
                )})
            }
        </ResponsiveGridLayout>
    );
}));

export default ChartsLayout;